import html2pdf from 'html2pdf.js';

export const formatTime = (time) => {
  const mins = Math.floor(time / 60)
    .toString()
    .padStart(2, "0");
  const secs = Math.floor(time % 60)
    .toString()
    .padStart(2, "0");
  return `${mins}:${secs}`;
};


export const convertTimeToMinutes = (timeString) => {
  if (!timeString) return "00:00";
  const [hours, minutes, seconds] = timeString.split(":").map(Number);
  const totalSeconds = hours * 3600 + minutes * 60 + seconds;
  const finalMinutes = Math.floor(totalSeconds / 60);
  const finalSeconds = totalSeconds % 60;
  return `${String(finalMinutes).padStart(2, "0")}:${String(
    finalSeconds
  ).padStart(2, "0")}`;
};





// new helpers
export const convertCallDuration = (timeString) => {
  if (!timeString) return "0 sec";

  const [hours, minutes, seconds] = timeString.split(":").map(Number);
  const totalSeconds = hours * 3600 + minutes * 60 + seconds;

  // If total duration is less than 60 seconds, show in seconds
  if (totalSeconds < 60) {
    return `${totalSeconds} sec`;
  }

  // If 60 seconds or more, show in minutes
  const finalMinutes = Math.floor(totalSeconds / 60);
  const remainingSeconds = totalSeconds % 60;

  // If there are remaining seconds, show them too
  if (remainingSeconds > 0) {
    return `${finalMinutes}:${String(remainingSeconds).padStart(2, "0")} min`;
  } else {
    return `${finalMinutes} min`;
  }
};


// Alternative 
export const convertCallDurationSimple = (timeString) => {
  if (!timeString) return "0 sec";

  const [hours, minutes, seconds] = timeString.split(":").map(Number);
  const totalSeconds = hours * 3600 + minutes * 60 + seconds;

  // If total duration is less than 60 seconds, show in seconds
  if (totalSeconds < 60) {
    return `${totalSeconds} sec`;
  }

  // If 60 seconds or more, show in minutes (rounded up if there are remaining seconds)
  const finalMinutes = Math.ceil(totalSeconds / 60);
  return `${finalMinutes} min`;
};




export function getFirstLetter(name) {
  if (!name || typeof name !== "string") return "";

  const trimmed = name.trim();
  return trimmed[0];
}

export const formatDuration = (durationStr) => {
  if (!durationStr || typeof durationStr !== "string") return "0s";

  const parts = durationStr.split(":").map(Number);
  if (parts.length !== 3) return "0s";

  const [h, m, s] = parts;

  let result = [];
  if (h > 0) result.push(`${h}h`);
  if (m > 0) result.push(`${m}m`);
  if (s > 0) result.push(`${s}s`);

  return result.length > 0 ? result.join(" ") : "0s";
};



export const formatName = (fullName) => {
  if (!fullName) return ""; // handle empty/null name

  const parts = fullName.trim().split(" ").filter(Boolean);

  const firstName = parts[0];
  const formattedFirstName =
    firstName[0].toUpperCase() + firstName.slice(1).toLowerCase();

  if (parts.length === 1) {
    // Only first name
    return formattedFirstName;
  }

  const lastInitial = parts[1][0].toUpperCase();
  return `${formattedFirstName} ${lastInitial}.`;
};





export const generateInvoicePDF = (data) => {
  const { companyName, month, dashboardMatrics, costPerAgent } = data;

  // Define the HTML structure with Tailwind-like inline styles for maximum compatibility
  const htmlTemplate = `
        <div style="padding: 40px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #334155; line-height: 1.5;">
            <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 40px;">
                <div>
                    <h1 style="margin: 0; color: #0f172a; font-size: 32px; letter-spacing: -0.025em;">INVOICE</h1>
                    <p style="margin: 4px 0 0 0; color: #64748b; font-weight: 500;">${companyName.toUpperCase()} SERVICES</p>
                </div>
                <div style="text-align: right;">
                    <div style="background: #f1f5f9; padding: 8px 16px; border-radius: 6px; display: inline-block;">
                        <span style="color: #64748b; font-size: 12px; text-transform: uppercase; font-weight: bold;">Statement Period</span>
                        <div style="font-size: 16px; color: #0f172a; font-weight: 600;">${month}</div>
                    </div>
                </div>
            </div>

            <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin-bottom: 40px;">
                ${[
      { label: 'Total Calls', value: dashboardMatrics.totalCalls, unit: '' },
      { label: 'Total Minutes', value: dashboardMatrics.formattedMinutes, unit: 'm' },
      { label: 'Total Cost', value: dashboardMatrics.totalCost, unit: '$' },
      { label: 'Due Amount', value: dashboardMatrics.dueAmount, unit: '$' }
    ].map(item => `
                    <div style="border: 1px solid #e2e8f0; padding: 16px; border-radius: 12px;">
                        <div style="font-size: 11px; color: #94a3b8; font-weight: 700; text-transform: uppercase; margin-bottom: 8px;">${item.label}</div>
                        <div style="font-size: 20px; color: #1e293b; font-weight: 700;">
                            ${item.unit === '$' ? '$' + item.value.toLocaleString() : item.value + item.unit}
                        </div>
                    </div>
                `).join('')}
            </div>

            <div style="margin-bottom: 20px;">
                <h3 style="font-size: 16px; color: #0f172a; margin-bottom: 16px;">Agent Breakdown</h3>
                <table style="width: 100%; border-collapse: collapse; font-size: 13px;">
                    <thead>
                        <tr style="border-bottom: 2px solid #f1f5f9; text-align: left;">
                            <th style="padding: 12px 8px; color: #64748b; font-weight: 600;">AGENT DETAILS</th>
                            <th style="padding: 12px 8px; color: #64748b; font-weight: 600;">CALLS</th>
                            <th style="padding: 12px 8px; color: #64748b; font-weight: 600;">MINUTES</th>
                            <th style="padding: 12px 8px; color: #64748b; font-weight: 600; text-align: right;">TOTAL COST</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${costPerAgent.map(agent => `
                            <tr style="border-bottom: 1px solid #f8fafc;">
                                <td style="padding: 16px 8px;">
                                    <div style="font-weight: 600; color: #1e293b;">${agent.agentFullName}</div>
                                    <div style="font-size: 11px; color: #94a3b8;">ID: ${agent.agentId}</div>
                                </td>
                                <td style="padding: 16px 8px;">${agent.totalCalls}</td>
                                <td style="padding: 16px 8px;">${agent.totalMinutes.toFixed(2)}</td>
                                <td style="padding: 16px 8px; text-align: right; font-weight: 600; color: #0f172a;">
                                    $${agent.totalCost.toFixed(2)}
                                </td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>
            </div>

            <div style="margin-top: 60px; padding-top: 20px; border-top: 1px solid #f1f5f9; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <p style="font-size: 11px; color: #94a3b8; margin: 0;">Next Invoice Date: ${dashboardMatrics.nextInvoiceGeneration}</p>
                </div>
                <div style="font-size: 11px; color: #94a3b8;">
                    Generated on ${new Date().toLocaleDateString()}
                </div>
            </div>
        </div>
    `;

  const element = document.createElement('div');
  element.innerHTML = htmlTemplate;

  const opt = {
    margin: [10, 10],
    filename: `Invoice_${companyName}_${month}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 3, useCORS: true, letterRendering: true },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  };

  return html2pdf().set(opt).from(element).save();
};